import lodash from 'lodash'
import { useMemo } from 'react'

import { useField } from '../../../../../../1stlog-ui/src/components/Field'

const useRequireConfirmation = ({ pickup, delivery } = {}) => {
  const requiresConfirmationPickup1 = useField(
    'pickup.pickupTime.settings.requiresConfirmation',
    { ignorePrefix: true },
  )
  const requiresConfirmationPickup2 = useField(
    'pickup.deliveryTime.settings.requiresConfirmation',
    { ignorePrefix: true },
  )
  const requiresConfirmationDelivery1 = useField(
    'delivery.pickupTime.settings.requiresConfirmation',
    { ignorePrefix: true },
  )
  const requiresConfirmationDelivery2 = useField(
    'delivery.deliveryTime.settings.requiresConfirmation',
    { ignorePrefix: true },
  )

  const isRequired = useMemo(() => {
    return (
      (pickup &&
        (requiresConfirmationPickup1 || requiresConfirmationPickup2)) ||
      (delivery &&
        (requiresConfirmationDelivery1 || requiresConfirmationDelivery2))
    )
  }, [
    requiresConfirmationPickup1,
    requiresConfirmationPickup2,
    requiresConfirmationDelivery1,
    requiresConfirmationDelivery2,
    pickup,
    delivery,
  ])

  return { isRequired }
}

export default useRequireConfirmation
